const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMjBhMiAyIDAgMCAxLTIgMkg1YTIgMiAwIDAgMS0yLTJoMTh6TTE1IDJhMiAyIDAgMCAxIDIgMnY3aDVsLTEwIDguNTg1TDIgMTFoNVY0YTIgMiAwIDAgMSAyLTJoNnptMCAySDl2OUg3LjcwM0wxMiAxNi45NSAxNi4yOTcgMTNIMTVWNHoiICBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
export {
  M as default
};
//# sourceMappingURL=download-b88c54d2.mjs.map
